import { Card, CardContent } from "@/shared/ui/card"
import socialcards from "@assets/socialcards.png"
import example from "@assets/example.png"
import { motion } from "motion/react"

const FeatureGrid = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay: 4,
          ease: "easeOut",
        }}
        className="w-full hidden lg:grid grid-cols-3 md:grid-rows-8 gap-4 max-w-6xl h-[65vh]">
        <Card className=" md:row-span-4 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF] ">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">True Autonomy</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">Think of it like a persistent brand memory, the The intelligent layer that preserves brand identity across every creative workflow.</p>
            <p className="font-poppins font-medium text-[#DA00E3] tracking-wide">No Edits. No Rework. Zero Slop.</p>
          </CardContent>
        </Card>
        <Card className="row-span-4 col-start-1 row-start-5 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">Agency Experience at SaaS Speeds</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
          </CardContent>
        </Card>
        <Card className="row-span-8 col-start-2 row-start-1 overflow-hidden border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col items-center gap-1">
            <img src={socialcards} className="w-[30rem] !max-w-[40rem]" />
            <h3 className="font-poppins font-semibold text-white w-full">Agency Experience at SaaS Speeds</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
            <Card className="border border-[#6519CF] w-full bg-transparent mt-2">
              <CardContent className="flex flex-col gap-3 px-4 py-3">
                <p className="text-[0.6rem] uppercase text-[#A566FF]">All Channnels</p>
                <p className="text-xs text-gray-200 font-poppins tracking-wide">"We help brands find their voice and keep it alive."</p>
              </CardContent>
            </Card>
          </CardContent>
        </Card>
        <Card className="row-span-4 col-start-3 row-start-1 overflow-hidden border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col items-center justify-end gap-1">
            <img src={example} className="w-[30rem] !max-w-[40rem] mb-3" />
            <h3 className="font-poppins font-semibold text-white w-full">Zero Prompt Ideation</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">siAi learns with each interaction and content that you approve, refine and reject.</p>
          </CardContent>
        </Card>
        <Card className="row-span-4 col-start-3 row-start-5 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">From one spark to every feed. Flawlessly on-brand.</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">siAi transforms one idea into content relevant for each platform, generative tool or content medium.</p>
          </CardContent>
        </Card>
      </motion.div>


      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay: 4,
          ease: "easeOut",
        }}
        className="w-full max-w-6xl h-[80vh] hidden md:max-lg:grid grid-cols-3 grid-rows-6 gap-4 px-5">
        <Card className="row-span-3 col-start-3 row-start-1 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF] overflow-hidden">
          <CardContent className="size-full flex flex-col items-center justify-end gap-1">
            <img src={example} className="w-[30rem] !max-w-[40rem] mb-3" />
            <h3 className="font-poppins font-semibold text-white w-full">Zero Prompt Ideation</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">siAi learns with each interaction and content that you approve, refine and reject.</p>
          </CardContent>
        </Card>
        <Card className="row-span-3 col-start-3 row-start-4 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">From one spark to every feed. Flawlessly on-brand.</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">siAi transforms one idea into content relevant for each platform, generative tool or content medium.</p>
          </CardContent>
        </Card>
        <Card className="row-span-3 col-start-2 row-start-1 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">Agency Experience at SaaS Speeds</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
          </CardContent>
        </Card>
        <Card className="row-span-3 col-start-1 row-start-1 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end">
            <h3 className="font-poppins font-semibold text-white">True Autonomy</h3>
            <p className="text-sm text-gray-200 font-poppins tracking-wide">Think of it like a persistent brand memory, the The intelligent layer that preserves brand identity across every creative workflow.</p>
            <p className="font-poppins font-medium text-[#DA00E3] tracking-wide">No Edits. No Rework. Zero Slop.</p>
          </CardContent>
        </Card>
        <Card className="col-span-2 row-span-3 col-start-1 row-start-4 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col items-center gap-1">
            <img src={socialcards} className="w-44 h-auto" />
            <div className="flex flex-col gap-1">
              <h3 className="font-poppins font-semibold text-white w-full">Agency Experience at SaaS Speeds</h3>
              <p className="text-sm text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
              <Card className="border border-[#6519CF] w-full bg-transparent mt-2">
                <CardContent className="flex flex-col gap-3 px-4 py-3">
                  <p className="text-[0.6rem] uppercase text-[#A566FF]">All Channnels</p>
                  <p className="text-xs text-gray-200 font-poppins tracking-wide">"We help brands find their voice and keep it alive."</p>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>
      </motion.div>


      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay: 4,
          ease: "easeOut",
        }}
        className="w-full max-w-6xl min-h-[100vh] hidden max-md:grid grid-cols-1 grid-rows-6 gap-4">
        <Card className="row-span-2 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col min-h-80 items-center gap-1">
            <img src={socialcards} className="w-full sm:w-2/3 h-auto" />
            <div className="flex flex-col gap-1">
              <h3 className="font-poppins font-semibold text-white w-full">Agency Experience at SaaS Speeds</h3>
              <p className="text-xs text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
              <Card className="border border-[#6519CF] w-full bg-transparent mt-2">
                <CardContent className="flex flex-col gap-3 px-4 py-2">
                  <p className="text-[0.6rem] uppercase text-[#A566FF]">All Channnels</p>
                  <p className="text-xs text-gray-200 font-poppins tracking-wide">"We help brands find their voice and keep it alive."</p>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>
        <Card className="row-start-3 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF] overflow-hidden">
          <CardContent className="size-full flex flex-col items-center justify-end gap-1 p-5">
            <img src={example} className="w-full" />
            <div className="w-full flex flex-col gap-1">
              <h3 className="font-poppins font-semibold text-white w-full">Zero Prompt Ideation</h3>
              <p className="text-xs text-gray-200 font-poppins tracking-wide">siAi learns with each interaction and content that you approve, refine and reject.</p>
            </div>
          </CardContent>
        </Card>
        <Card className="row-start-4 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end p-5">
            <h3 className="font-poppins font-semibold text-white">From one spark to every feed. Flawlessly on-brand.</h3>
            <p className="text-xs text-gray-200 font-poppins tracking-wide">siAi transforms one idea into content relevant for each platform, generative tool or content medium.</p>
          </CardContent>
        </Card>
        <Card className="row-start-5 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-2 justify-end p-5">
            <h3 className="font-poppins font-semibold text-white">Agency Experience at SaaS Speeds</h3>
            <p className="text-xs text-gray-200 font-poppins tracking-wide">OS² is your bespoke, on-brand agent that delivers customized content without the slowdown of constant human intervention.</p>
          </CardContent>
        </Card>
        <Card className="row-start-6 border bg-gradient-to-b from-[#2A0163] to-[#320177] border-[#6519CF]">
          <CardContent className="size-full flex flex-col gap-1 justify-end p-5">
            <h3 className="font-poppins font-semibold text-white">True Autonomy</h3>
            <p className="text-xs text-gray-200 font-poppins tracking-wide">Think of it like a persistent brand memory, the The intelligent layer that preserves brand identity across every creative workflow.</p>
            <p className="font-poppins text-xs font-medium text-[#DA00E3] tracking-wide">No Edits. No Rework. Zero Slop.</p>
          </CardContent>
        </Card>
      </motion.div>

    </>
  )
}

export default FeatureGrid;
